module.exports = __webpack_public_path__ + "img/physics.ff220f1c.png";